<div class="ai-summary-container">
  <header (click)="openSummary()" [class.collapsed]="isCollapsed" class="clickable">
    <ion-icon src="assets/imgs/exeevo-logo.svg"></ion-icon>
    <h3>{{ (isCollapsed || !loading ? 'AI_SUMMARY' : 'AI_SUMMARY_LOADING') | translate }}</h3>
    @if (!isCollapsed) {
    @if (!loading && !regenerating && generatedLabel) {
    <span class="generated-at">{{ generatedLabel }}</span>
    }
    <!-- Regenerating needs the agent, so the control is gone offline; the brief itself stays. -->
    @if (isOnline$ | async) {
    <button
      type="button"
      class="regenerate-btn"
      [attr.aria-label]="'AI_SUMMARY_REGENERATE' | translate"
      [attr.title]="'AI_SUMMARY_REGENERATE' | translate"
      [disabled]="loading || regenerating"
      (click)="regenerate(); $event.stopPropagation()">
      <ion-icon name="refresh-outline" [class.spinning]="loading || regenerating" aria-hidden="true"></ion-icon>
    </button>
    }
    }
  </header>
  @if (!isCollapsed) {
  <div class="ai-summary-content" [class.maximized]="isMaximized">
    @if (loading) {
    <p class="skeleton-text">
      <ion-skeleton-text class="skeleton-text-animated"></ion-skeleton-text>
      <ion-skeleton-text class="skeleton-text-animated skeleton-text-partial"></ion-skeleton-text>
    </p>
    } @else {
    @if (summary$ | async; as summary) {
    @if (summary.text) {
    <div class="full-text" [class.show-text]="isMaximized" [innerHTML]="summary.text | safe:'html'">
    </div>
    @if (isMaximized) {
    <p style="text-align: right;">
      <a (click)="toggleMaximize(); $event.stopPropagation()" class="read-more-link">{{
        'READ_LESS' | translate }}</a>
    </p>
    }
    @if (isMinimized) {
    <div class="clamped-text" [class.show-text]="!isMaximized">
      <div [innerHTML]="summary.text | safe:'html'"></div>
      <span class="read-more-container">
        <span class="fade"></span>
        @if (hasReadMore) {
        <a (click)="toggleMaximize(); $event.stopPropagation()" class="read-more-link">{{
          isMaximized ? ('READ_LESS' | translate) : ('READ_MORE' | translate) }}</a>
        }
      </span>
    </div>
    }
    @if (summary.progress) {
    <p class="progress-text">
      {{ summary.progress }}
    </p>
    }
    } @else if (isOffline$ | async) {
    <!-- Nothing was ever generated for this record, and offline nothing can be. -->
    <div class="offline-message">
      <ion-icon name="cloud-offline-outline" class="offline-icon"></ion-icon>
      <p>{{ 'AI_SUMMARY_OFFLINE_MESSAGE' | translate }}</p>
    </div>
    }
    }
    }
  </div>
  @if (showDisclaimer || responseId) {
  <div class="ai-summary-meta">
    @if (showDisclaimer) {
    <p class="ai-summary-meta__disclaimer">
      <span class="disclaimer-text">{{ 'AI_SUMMARY_DISCLAIMER' | translate }}</span>
    </p>
    }
    @if (responseId) {
    <nova-feedback-footer
      class="ai-summary-meta__feedback"
      [responseId]="responseId"
      [usage]="usage"
      (feedback)="onFeedback($event)">
    </nova-feedback-footer>
    }
  </div>
  }
  }
</div>
